import { gql } from '@apollo/client';

// checkout.com Flow migration. Flow does not consume a client-side card token like Frames did up
// front; instead the backend creates a checkout.com "payment session" (server-side, with the secret
// key) which the Flow SDK initialises with to render the card fields. The WEB SDK is initialised with
// the base64 `paymentSessionToken` (checkout.com's `payment_session_token`) — NOT the `pss_...`
// `paymentSessionSecret` (which is what the mobile SDK uses).
export const CREATE_PAYMENT_SESSION = gql`
  mutation CreatePaymentSession($paymentSession: PaymentSessionInput!) {
    createPaymentSession(paymentSession: $paymentSession) {
      errorMessage
      id
      paymentSessionSecret
      paymentSessionToken
      referenceId
    }
  }
`;
